export const formatPhoneNumber = (digits) => {
  if (!digits) return ""; // If no digits, return empty string (erases everything)

  const areaCode = digits.slice(0, 3);
  const centralOfficeCode = digits.slice(3, 6);
  const stationCode = digits.slice(6, 10);

  let formatted = `+1 (${areaCode}`;

  if (digits.length > 3) {
    formatted += `) ${centralOfficeCode}`;
  }
  if (digits.length > 6) {
    formatted += `-${stationCode}`;
  }

  return formatted;
};
